<template>
    <div style="display: inline-block">
        <div class="bgChart" v-show="showOptions" @click="closeOptions"></div>
        <div class="options-wrapper">
            <div class="options-button" @click="toggleOptions">Chart Options</div>
            <div class="options" :class="showOptionsList" v-if="showOptions">
                <div class="inputWrapper">
                    <dropdownInput
                        title="X Axis"
                        :options="valueOptions"
                        index="0"
                        mutationRef="XaxisSelection"
                        :presetValue="originalXaxis"
                        :multi="false"
                        @input="updateChart"
                    />
                    <dropdownInput
                        title="Y Axis"
                        :options="valueOptions"
                        index="1"
                        mutationRef="YaxisSelection"
                        :presetValue="originalYaxis"
                        :multi="false"
                        @input="updateChart"
                    />
                    <dropdownInput
                        title="Radius"
                        :options="valueOptionsRadius"
                        index="2"
                        mutationRef="RaxisSelection"
                        :presetValue="originalRaxis"
                        :multi="false"
                        @input="updateChart"
                    />
                    <dropdownInput
                        title="Colour"
                        :options="categoryOptions"
                        index="3"
                        mutationRef="ColourSelection"
                        :presetValue="originalColour"
                        :multi="false"
                        @input="updateChart"
                    />
                    <dropdownInput
                        title="Tooltip"
                        :options="tooltipOptions"
                        index="3"
                        mutationRef="TooltipSelection"
                        :presetValue="originalTooltip"
                        :multi="false"
                        @input="updateChart"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import vOutsideEvents from 'vue-outside-events';

Vue.use(vOutsideEvents);
export default {
    name: 'chartOptions',
    data () {
        return {
            showOptions: false,
            originalColour: '',
            originalRaxis: '',
            originalXaxis: '',
            originalYaxis: '',
            originalTooltip: '',
            tooltipOptions: ['General', 'Infrastructure'],
        };
    },
    beforeMount () {
        this.defaultSetup();
    },
    methods: {
        updateChart (value) {
            value.name === 'XaxisSelection'
                ? this.$store.commit(
                    'chart/updateXaxisSelection',
                    value.options,
                )
                : '';
            value.name === 'YaxisSelection'
                ? this.$store.commit(
                    'chart/updateYaxisSelection',
                    value.options,
                )
                : '';
            value.name === 'RaxisSelection'
                ? this.$store.commit(
                    'chart/updateRaxisSelection',
                    value.options,
                )
                : '';
            value.name === 'ColourSelection'
                ? this.$store.commit(
                    'chart/updateColourSelection',
                    value.options,
                )
                : '';
            value.name === 'TooltipSelection'
                ? this.$store.commit(
                    'chart/updateTooltipSelection',
                    value.options,
                )
                : '';
        },
        toggleOptions () {
            this.showOptions = !this.showOptions;
        },
        closeOptions () {
            this.showOptions = false;
        },
        defaultSetup () {
            this.originalXaxis = this.$store.state.chart.xAxisSelection;
            this.originalYaxis = this.$store.state.chart.yAxisSelection;
            this.originalRaxis = this.$store.state.chart.raxisSelection;
            this.originalColour = this.$store.state.chart.colourSelection;
            this.originalTooltip = this.$store.state.chart.tooltipSelection;
        },
    },
    computed: {
        valueOptions () {
            const ret = [];
            for (const n in this.$store.state.universe.data.valueDimensions) {
                ret.push(
                    this.$store.state.universe.data.valueDimensions[n].name,
                );
            }
            return ret;
        },
        valueOptionsRadius () {
            const ret = [];
            for (const n in this.$store.state.universe.data.valueDimensions) {
                if (this.$store.state.universe.data.valueDimensions[n].isRadius) {
                    ret.push(
                        this.$store.state.universe.data.valueDimensions[n].name,
                    );
                }
            }
            return ret;
        },
        categoryOptions () {
            const ret = ['Pinned Funds'];
            for (const n in this.$store.state.universe.data.categoryDimensions) {
                ret.push(
                    this.$store.state.universe.data.categoryDimensions[n].name,
                );
            }
            return ret.sort();
        },
        showOptionsList () {
            return this.showOptions ? 'show' : '';
        },
        fullscreen () {
            return this.$store.state.ui.fullScreen;
        },
    },
    watch: {
        fullscreen () {
            if (this.fullscreen) {
                this.defaultSetup();
            }
		},
		showOptions () {
			this.defaultSetup();
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "src/assets/scss/all.scss";
.bgChart {
    position: absolute;
    top: 0;
    left: 0%;
    right: 0;
    bottom: 0;
    z-index: 1;
}
.options-wrapper {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    z-index: 2;
    .options-button {
        background: $darkBlue;
        border-radius: 6px;
        color: white;
        cursor: pointer;
        padding: 6px 12px;
        text-align: center;
        margin-right: 5px;
    }

    .options {
        -moz-border-radius: 0.4167rem;
        -ms-border-radius: 0.4167rem;
        -o-border-radius: 0.4167rem;
        -webkit-border-radius: 0.4167rem;
        background-color: white;
        border-radius: 0.4167rem;
        border: 2px solid $darkBlue;
        box-shadow: 0 9px 23px rgba(0, 0, 0, 0.09),
            0 5px 5px rgba(0, 0, 0, 0.06) !important;
        display: none;
        padding: 20px;
        position: absolute;
        right: -100px;
        top: 50px;
        width: 500px;
        z-index: 1;
        @include easeInOut(0.5s);
        &:after,
        &:before {
            border: solid transparent;
            bottom: 100%;
            content: " ";
            height: 0;
            pointer-events: none;
            position: absolute;
            width: 0;
        }
        &:after {
            border-bottom-color: #ffffff;
            border-color: transparent;
            border-width: 10px;
            margin-left: -10px;
            right: 221px;
        }
        &:before {
            border-bottom-color: $darkBlue;
            border-color: transparent;
            border-width: 16px;
            margin-left: -16px;
            right: 215px;
        }
        &.show {
            display: block;
        }
        .legendItem {
            float: left;
            margin-bottom: 20px;
            width: 33%;
            .color {
                border-radius: 10px;
                float: left;
                height: 20px;
                margin-right: 10px;
                width: 20px;
            }
        }
        .inputWrapper {
            margin-top: 15px;

            .multiselect {
                width: 100%;
            }
            &:first-child {
                margin-top: 0;
            }

            .inputTitle {
                color: #002c5c;
                font-size: 14px;
                font-weight: 700;
                .icon-rotate-cw {
                    float: right;
                    cursor: pointer;
                }
            }
            .fund-counter {
                // display: inline-block;
                float: right;
                padding: 6px;
                .funds {
                    font-weight: bold;
                    color: $LCPBlue;
                    padding: 6px;
                    background: #f3f3f3;
                    border-radius: 6px;
                    .muted {
                        color: $darkGrey;
                    }
                }
            }
        }
    }
}
</style>
